module.exports = __webpack_public_path__ + "img/badge-volume-red.5d3fee2e.svg";